import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Layout Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// Section Components
import HeroSection from './components/sections/HeroSection';
import PractitionersSection from './components/sections/PractitionersSection';
import ProcessSection from './components/sections/ProcessSection';
import ProblemsSection from './components/sections/ProblemsSection';
import BrandSection from './components/sections/BrandSection';
import ClientsSection from './components/sections/ClientsSection';
import StatsSection from './components/sections/StatsSection';
import FAQSection from './components/sections/FAQSection';
import TeamSection from './components/sections/TeamSection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[var(--bg-page)]">
      <Header />
      <main>
        <HeroSection />
        <PractitionersSection />
        <ProcessSection />
        <ProblemsSection />
        <BrandSection />
        <StatsSection />
        <ClientsSection />
        <FAQSection />
        <TeamSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
